const VideoView = ({ topic }) => {
  const isYouTube =
    topic.videoUrl && topic.videoUrl.includes("youtube.com");

  const youtubeId = isYouTube
    ? new URL(topic.videoUrl).searchParams.get("v")
    : null;

  return (
    <div className="space-y-6">
      {isYouTube && youtubeId ? (
        <div className="aspect-video bg-black rounded-2xl overflow-hidden shadow-lg">
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}`}
            title="Video"
            allowFullScreen
            className="w-full h-full"
          />
        </div>
      ) : (
        <div className="aspect-video bg-black rounded-2xl overflow-hidden shadow-lg">
          <video controls className="w-full h-full">
            <source src={topic.videoUrl} />
          </video>
        </div>
      )}

    </div>
  );
};

export default VideoView;
